module.exports = __webpack_public_path__ + "static/media/family-medium.be7d17b0.png";